import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "audio-player" }
const _hoisted_2 = {
  class: "controls-row",
  ref: "row"
}
const _hoisted_3 = {
  ref: "player",
  playsinline: "",
  controls: false,
  class: "hidden-audio",
  crossorigin: "anonymous",
  preload: "auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        ref: "btn",
        icon: "",
        variant: "text",
        color: _ctx.btnColor,
        size: _ctx.btnSize,
        ripple: false,
        disabled: !_ctx.hasAudio,
        onClick: _ctx.togglePlay,
        density: "comfortable"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: _ctx.isPlaying ? 'mdi-pause-circle-outline' : 'mdi-play-circle-outline'
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["color", "size", "disabled", "onClick"]),
      _createElementVNode("canvas", {
        ref: "canvas",
        style: _normalizeStyle({ height: _ctx.canvHeight + 'px', width: '100%' })
      }, null, 4)
    ], 512),
    _createElementVNode("audio", _hoisted_3, null, 512)
  ]))
}